import React, { useState } from 'react';
import {
  Modal,
  Row,
  Col,
  Select,
  Input,
  InputNumber,
  Alert,
  Form,
  message,
} from 'antd';
import PropTypes from 'prop-types';
import './style.scss';
import { BANKS_LIST } from './utils/constants';
import PdButton from 'components/pd-button';
import DisbursementService from 'services/disbursement';
import { get, isEmpty } from 'lodash';
import { convertNumberToRupiahCurrency } from 'utils';

function ModalReturnBankUpdate({
  order,
  customerName,
  bankDetail,
  onSubmitSuccess = () => {},
  ...props
}) {
  const [form] = Form.useForm();
  const [error, setError] = useState({});
  const [fetching, setFetching] = useState(false);

  async function handleSubmit(values) {
    try {
      setFetching(true);
      const returnData = await DisbursementService.updateBank(order.id, {
        return: {
          bank_code: BANKS_LIST[values.bank],
          bank_name: values.bank,
          account_number: values.account_number,
          account_holder: values.account_holder,
        },
      });
      // TODO need lang service, but no text from design provided
      onSubmitSuccess(returnData);
      message.success('bank update success');
    } catch (e) {
      setError(e);
    } finally {
      setFetching(false);
    }
  }

  return (
    <>
      <Modal className="pd-modalRequestReturn" {...props} footer={null}>
        <h1 className="title">Return Request</h1>
        {isEmpty(order) ? (
          <Row>
            <Alert type="error" showIcon message={'no order selected'} />
          </Row>
        ) : (
          <Row justify="center" className="mb-15">
            <Col lg={{ span: 8, offset: 4 }}>Total Payment</Col>
            <Col lg={11} className="order-value">
              {convertNumberToRupiahCurrency(+order.net_price)}
            </Col>
            <Col lg={{ span: 8, offset: 4 }}>Invoice No</Col>
            <Col lg={11} className="order-value">
              {order.invoice_number}
            </Col>
            <Col lg={{ span: 8, offset: 4 }}>Customer Name</Col>
            <Col lg={11} className="order-value">
              {customerName}
            </Col>
          </Row>
        )}
        {/* TODO no inline style  */}
        <Row style={{ marginBottom: '1rem' }}>
          {error.message && (
            <Alert
              message={error.message}
              type="error"
              showIcon
              closable
              onClose={() => {
                setError(null);
              }}
            />
          )}
        </Row>

        <Form
          form={form}
          onFinish={handleSubmit}
          initialValues={{
            bank: get(bankDetail, 'bank_name', ''),
            account_number: get(bankDetail, 'account_number', ''),
            account_holder: get(bankDetail, 'account_holder', ''),
          }}>
          <Input.Group size="large">
            <Form.Item
              name="bank"
              rules={[
                {
                  required: true,
                  message: 'select a bank',
                },
              ]}>
              <Select
                size="large"
                style={{ width: '100%' }}
                placeholder="Select the bank of your account">
                {Object.keys(BANKS_LIST).map((bank) => {
                  return <Select.Option key={bank}>{bank}</Select.Option>;
                })}
              </Select>
            </Form.Item>
            <Form.Item
              name="account_number"
              rules={[
                {
                  required: true,
                  message: 'Enter account number',
                },
              ]}>
              <InputNumber
                size="large"
                placeholder="Enter your account number"
                style={{ width: '100%' }}
              />
            </Form.Item>
            <Form.Item
              name="account_holder"
              rules={[
                {
                  required: true,
                  message: 'Enter account holder name',
                },
              ]}>
              <Input placeholder="Enter account holder name" />
            </Form.Item>
            {/* TODO: improve centering, also related to antd row justify */}
            <Col span={8} offset={8}>
              <Form.Item>
                <PdButton
                  full
                  loading={fetching}
                  type="primary"
                  htmlType="submit">
                  Submit
                </PdButton>
              </Form.Item>
            </Col>
          </Input.Group>
        </Form>
      </Modal>
    </>
  );
}

ModalReturnBankUpdate.propTypes = {
  order: PropTypes.shape({
    id: PropTypes.number,
    net_price: PropTypes.string,
  }),
  bankDetail: PropTypes.any,
  customerName: PropTypes.string,
  onSubmitSuccess: PropTypes.func,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
};

export default ModalReturnBankUpdate;
